import React from "react"
import styled from "@emotion/styled"
import Container from "./container"
import { Link } from "gatsby"

const isBrowser = typeof window !== "undefined"
const firebase = isBrowser ? require("firebase/app") : "div"
const firestore = isBrowser ? require("firebase/firestore") : "div"

const Styles = styled.footer`
  .my-footer {
    padding: 4px;
    background: #6d2f9ce7;
  }

  .my-footer-2 {
    padding: 6px;
    background: #9c2f2fe7;
    
  }

  .my-purple-link {
    color: #c7add9;
  }

  a {
    color: white;
  }

  .title {
    color: white;
    font-size: 24px;
    margin: 8px;
  }

  .my-grad-span {
    margin-right: 6px;
    font-size: 18px;
  }

  .my-grad-link {
    font-size: 18px;
    color: #e6b9b9;
  }



  

  
`
export default class Footer extends React.Component {
  constructor () {
    super();
    this.state = {}
    this.state.count = "";
  }
  async componentDidMount () {
    let graduates = await firebase.firestore().collection("profiles").where("graduated", "==", true).get();
    this.setState({ count: graduates.size })
  }
  render() {
    return (
      <Styles>
        <div className="my-footer">
          <Container>
            <div className="title has-text-centered">
              Learn to code for <span style={{ color: "#ffae1e" }}>free</span> in
            </div>

            <div className="title has-text-centered">
              <Link className="my-purple-link" to="/program">two months or less</Link>.
            </div>
          </Container>
        </div>


        <div className="my-footer-2">

            <div className="title has-text-centered">
              <Link to="/graduates">
            <span className="my-grad-span">
              { this.state.count }
            </span>

            <span className="my-grad-link">
            Graduate(s)
            </span>.
            </Link>
            </div>
            
        </div>
      </Styles>
    )
  }
}
